document.addEventListener("DOMContentLoaded", function () {
  const itemsPerPage = 12;
  const paginationContainer = document.getElementById("pagination-container");
  let currentPage = 1;

  // --- Elements for the new disabling function ---
  const productsDropdownWrapper = document.querySelector('.dropdown-list[data-select="products"]').closest('.custom-select');
  const productsSelectedDisplay = productsDropdownWrapper.querySelector('.selected');

  // Get the default "All Products" option to reset the display text
  const allProductsItem = productsDropdownWrapper.querySelector('li[data-value="all-products"]');
  const allProductsText = allProductsItem ? allProductsItem.querySelector('.option-title').innerText : 'Todos los Productos';
  // --------------------------------------------------

  function getVisibleItems() {
    return Array.from(document.querySelectorAll(".paginate:not(.hide)"));
  }

  function showPage(page) {
    currentPage = page;
    const visibleItems = getVisibleItems();
    const start = (page - 1) * itemsPerPage;
    const end = start + itemsPerPage;

    // Hide all items first
    document.querySelectorAll(".paginate").forEach(item => {
      item.style.display = "none";
    });

    // Show visible items for this page
    visibleItems.forEach((item, index) => {
      if (index >= start && index < end) {
        item.style.display = "block";
      }
    });

    renderPaginationControls(visibleItems.length);
  }

  // --- UPDATED PAGINATION WITH TRUNCATION LOGIC ---
  function renderPaginationControls(totalVisible) {
    paginationContainer.innerHTML = "";
    const totalPages = Math.ceil(totalVisible / itemsPerPage);

    if (totalPages <= 1) return;

    // Prev button
    const prevBtn = document.createElement("button");
    prevBtn.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0300/6637/6788/files/Component_1.png?v=1758516497">';
    prevBtn.disabled = currentPage === 1;
    prevBtn.addEventListener("click", () => showPage(currentPage - 1));
    paginationContainer.appendChild(prevBtn);

    // Pagination Number Logic
    const range = 1; // Number of pages to show around current page
    let pages = [];

    for (let i = 1; i <= totalPages; i++) {
      if (i === 1 || i === totalPages || (i >= currentPage - range && i <= currentPage + range)) {
        pages.push(i);
      }
    }

    let l;
    for (let i of pages) {
      if (l) {
        if (i - l === 2) {
          addPageButton(l + 1);
        } else if (i - l !== 1) {
          const ellipsis = document.createElement("span");
          ellipsis.innerText = "...";
          ellipsis.className = "pagination-dots";
          paginationContainer.appendChild(ellipsis);
        }
      }
      addPageButton(i);
      l = i;
    }

    function addPageButton(i) {
      const btn = document.createElement("button");
      btn.innerText = i;
      btn.className = (i === currentPage) ? "active" : "";
      btn.addEventListener("click", () => showPage(i));
      paginationContainer.appendChild(btn);
    }

    // Next button
    const nextBtn = document.createElement("button");
    nextBtn.innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0300/6637/6788/files/Vector.png?v=1758512062">';
    nextBtn.disabled = currentPage === totalPages;
    nextBtn.addEventListener("click", () => showPage(currentPage + 1));
    paginationContainer.appendChild(nextBtn);
  }

  function refreshPagination() {
    showPage(1);
  }

  // ------------------------------------
  // DROPDOWN FILTER SCRIPT (Maintained)
  // ------------------------------------
  const selectedValues = {
    collections: null,
    products: null,
    cups: null,
  };

  const imageItem = document.querySelectorAll('.content-sizing-area__result-item');
  const inserts = ['rellenos-ultra-boost', 'rellenos-ultra-boost-lite', 'rellenos-demi-boost', 'rellenos-demi-boost-lite-rellenos-perfect-boost', 'rellenos-invisible-lift', 'rellenos-subtle-lift', 'rellenos-micro-lift-dos-pares'];
  const bras = ['brasier-adherible-con-acolchado-magico', 'brasier-adherible-boomba', 'brasier-demi-adherible-boomba', 'invisibra-boomba'];
  const tapes = ['cinta-corporal', 'cinta-corporal-reutilizable', 'magic-breast-lift'];

  function resetCollection() {
    imageItem.forEach(item => {
      item.classList.remove('hide', 'selected');
    });
  }

  function resetProductDropdownToAll() {
    selectedValues.products = null;
    productsSelectedDisplay.innerHTML = `<span>${allProductsText}</span>`;
    productsDropdownWrapper.querySelectorAll('li').forEach(item => {
      item.classList.remove('active');
      item.querySelector('.radio-circle')?.classList.remove('active');
    });
    if (allProductsItem) {
      allProductsItem.classList.add('active');
      allProductsItem.querySelector('.radio-circle')?.classList.add('active');
    }
  }

  function toggleProductDropdownState(shouldDisable) {
    if (shouldDisable) {
      productsDropdownWrapper.classList.add('disabled');
      productsSelectedDisplay.style.pointerEvents = 'none';
      resetProductDropdownToAll();
    } else {
      productsDropdownWrapper.classList.remove('disabled');
      productsSelectedDisplay.style.pointerEvents = '';
    }
    applyFilters();
  }

  function updateAvailableCups() {
    const { collections, products } = selectedValues;
    const availableSizes = new Set();

    imageItem.forEach(item => {
      const category = item.getAttribute('data-category');
      const size = item.getAttribute('data-size');
      let show = true;

      if (collections === 'adhesive-inserts') show = inserts.includes(category);
      else if (collections === 'body-tapes') show = tapes.includes(category);
      else if (collections === 'adhesive-bras') show = bras.includes(category);

      if (show && products) {
        if (products === 'ultra-boost') show = category === 'rellenos-ultra-boost';
        else if (products === 'ultra-boost-lite') show = category === 'rellenos-ultra-boost-lite';
        else if (products === 'demi-boost') show = category === 'rellenos-demi-boost';
        else if (products === 'demi-boost-lite') show = category === 'rellenos-demi-boost-lite-rellenos-perfect-boost';
        else if (products === 'invisible-lift') show = category === 'rellenos-invisible-lift';
        else if (products === 'subtle-lift-inserts') show = category === 'rellenos-subtle-lift';
        else if (products === 'micro-lift-inserts') show = category === 'rellenos-micro-lift-dos-pares';
        else if (products === 'magic-padded-sticky-bra') show = category === 'brasier-adherible-con-acolchado-magico';
        else if (products === 'sticky-bra') show = category === 'brasier-adherible-boomba';
        else if (products === 'demi-sticky-bra') show = category === 'brasier-demi-adherible-boomba';
        else if (products === 'invisibra') show = category === 'invisibra-boomba';
        else if (products === 'body-tape') show = category === 'cinta-corporal';
        else if (products === 'reusable-body-tape') show = category === 'cinta-corporal-reutilizable';
        else if (products === 'magic-breast-lift') show = category === 'magic-breast-lift';
      }

      if (collections === 'all-collections' && products) show = true;
      if (show && size) availableSizes.add(size);
    });

    const cupDropdown = document.querySelector('.dropdown-list[data-select="cups"]');
    if (cupDropdown) {
      cupDropdown.querySelectorAll('li').forEach(li => {
        const cupVal = li.getAttribute('data-value');
        if (cupVal === 'all') {
          li.classList.remove('disabled');
          li.style.pointerEvents = ""; li.style.opacity = "1";
          return;
        }
        if (!availableSizes.has(cupVal)) {
          li.classList.add('disabled'); li.style.pointerEvents = "none";
          li.style.opacity = "0.5"; li.style.color = "#d4d4d4";
        } else {
          li.classList.remove('disabled'); li.style.pointerEvents = "";
          li.style.opacity = "1"; li.style.color = "#222";
        }
      });
    }
  }

  function applyFilters() {
    resetCollection();
    const { collections, products, cups } = selectedValues;
    let hasMatch = false;
    updateAvailableCups();

    imageItem.forEach(item => {
      const category = item.getAttribute('data-category');
      const categorySize = item.getAttribute('data-size');
      let show = true;

      if (collections === 'adhesive-inserts') show = inserts.includes(category);
      else if (collections === 'body-tapes') show = tapes.includes(category);
      else if (collections === 'adhesive-bras') show = bras.includes(category);

      if (show && products && collections !== 'all-collections') {
        if (products === 'ultra-boost') show = category === 'rellenos-ultra-boost';
        else if (products === 'ultra-boost-lite') show = category === 'rellenos-ultra-boost-lite';
        else if (products === 'demi-boost') show = category === 'rellenos-demi-boost';
        else if (products === 'demi-boost-lite') show = category === 'rellenos-demi-boost-lite-rellenos-perfect-boost';
        else if (products === 'invisible-lift') show = category === 'rellenos-invisible-lift';
        else if (products === 'subtle-lift-inserts') show = category === 'rellenos-subtle-lift';
        else if (products === 'micro-lift-inserts') show = category === 'rellenos-micro-lift-dos-pares';
        else if (products === 'magic-padded-sticky-bra') show = category === 'brasier-adherible-con-acolchado-magico';
        else if (products === 'sticky-bra') show = category === 'brasier-adherible-boomba';
        else if (products === 'demi-sticky-bra') show = category === 'brasier-demi-adherible-boomba';
        else if (products === 'invisibra') show = category === 'invisibra-boomba';
        else if (products === 'body-tape') show = category === 'cinta-corporal';
        else if (products === 'reusable-body-tape') show = category === 'cinta-corporal-reutilizable';
        else if (products === 'magic-breast-lift') show = category === 'magic-breast-lift';
      }

      if (show && cups && cups !== 'all') show = categorySize === cups;

      if (show) {
        item.classList.remove('hide'); item.classList.add('selected');
        hasMatch = true;
      } else {
        item.classList.add('hide'); item.classList.remove('selected');
      }
    });

    const noResultEl = document.querySelector('.no-results-message');
    if (noResultEl) noResultEl.style.display = hasMatch ? 'none' : 'block';
    refreshPagination();
  }

  document.querySelectorAll('.custom-select').forEach(selectBox => {
    const selected = selectBox.querySelector('.selected');
    const dropdownTypes = ['collections', 'products', 'cups'];

    selected.addEventListener('click', () => {
      if (selectBox.classList.contains('disabled')) return;
      document.querySelectorAll('.custom-select').forEach(otherBox => {
        if (otherBox !== selectBox) otherBox.classList.remove('open');
      });
      selectBox.classList.toggle('open');
    });

    dropdownTypes.forEach(type => {
      const dropdown = selectBox.querySelector(`.dropdown-list[data-select="${type}"]`);
      if (!dropdown) return;
      dropdown.querySelectorAll('li').forEach(item => {
        item.addEventListener('click', () => {
          if (item.classList.contains('disabled')) return;
          const value = item.getAttribute('data-value');
          const title = item.querySelector('.option-title')?.innerText || '';
          selectedValues[type] = value;

          if (type === 'collections') {
            const isAllCollections = value === 'all-collections';
            toggleProductDropdownState(isAllCollections);
            const productDropdown = document.querySelector('.dropdown-list[data-select="products"]');
            if (productDropdown) {
              const productItems = productDropdown.querySelectorAll('li');
              const insertsCat = ['all-products', 'all-inserts', 'ultra-boost', 'ultra-boost-lite', 'demi-boost', 'demi-boost-lite', 'invisible-lift', 'subtle-lift-inserts', 'micro-lift-inserts'];
              const brasCat = ['all-products', 'all-bras', 'magic-padded-sticky-bra', 'sticky-bra', 'demi-sticky-bra', 'invisibra'];
              const tapesCat = ['all-products', 'all-tapes', 'body-tape', 'reusable-body-tape', 'magic-breast-lift'];
              const allCat = [...insertsCat, ...brasCat, ...tapesCat];

              productItems.forEach(productItem => {
                productItem.classList.remove('hide');
                const pVal = productItem.getAttribute('data-value');
                let validList = (value === 'adhesive-inserts') ? insertsCat : (value === 'adhesive-bras') ? brasCat : (value === 'body-tapes') ? tapesCat : allCat;
                if (validList.length && !validList.includes(pVal)) productItem.classList.add('hide');
              });
            }
          }

          selectBox.querySelectorAll('li').forEach(i => {
            i.classList.remove('active'); i.querySelector('.radio-circle')?.classList.remove('active');
          });
          item.classList.add('active'); item.querySelector('.radio-circle')?.classList.add('active');
          selected.innerHTML = `<span>${title}</span>`;
          applyFilters();
          selectBox.classList.remove('open');
        });
      });
    });
  });

  document.addEventListener('click', e => {
    document.querySelectorAll('.custom-select').forEach(box => {
      if (!box.contains(e.target)) box.classList.remove('open');
    });
  });

  document.querySelector('.reset-btn')?.addEventListener('click', () => {
    selectedValues.collections = null; selectedValues.products = null; selectedValues.cups = null;
    const allColl = document.querySelector('li[data-value="all-collections"]');
    if (allColl) selectedValues.collections = allColl.getAttribute('data-value');

    document.querySelectorAll('.custom-select').forEach(selectBox => {
      const selected = selectBox.querySelector('.selected');
      const defaultText = selected.getAttribute('data-placeholder') || 'Select';
      const selectType = selectBox.querySelector('.dropdown-list').getAttribute('data-select');
      selected.innerHTML = `<span>${defaultText}</span>`;
      selectBox.querySelectorAll('li').forEach(item => {
        item.classList.remove('active', 'hide');
        item.querySelector('.radio-circle')?.classList.remove('active');
      });
      let def;
      if (selectType === 'collections') def = selectBox.querySelector('li[data-value="all-collections"]');
      else if (selectType === 'products') def = selectBox.querySelector('li[data-value="all-products"]');
      else if (selectType === 'cups') def = selectBox.querySelector('li[data-value="all"]');
      if (def) { def.classList.add('active'); def.querySelector('.radio-circle')?.classList.add('active'); }
    });

    ['all-inserts', 'all-bras', 'all-tapes'].forEach(val => document.querySelector(`li[data-value="${val}"]`)?.classList.add('hide'));
    toggleProductDropdownState(true);
    applyFilters();
  });

  // Initial Load
  showPage(1);
  updateAvailableCups();
  if (document.querySelector('li[data-value="all-collections"]')?.classList.contains('active')) {
    toggleProductDropdownState(true);
  }
});